import { render, staticRenderFns } from "./program-category-view.vue?vue&type=template&id=3b31a294&"
import script from "./program-category-view.vue?vue&type=script&lang=js&"
export * from "./program-category-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports